// extracted by mini-css-extract-plugin
export default {"EntityListFilterEllipsis":"XhlYTdO1Bg4pg5AlHHJx"};